// extracted by mini-css-extract-plugin
export default {"card":"styles_card__q00TB","ctaWrapper":"styles_ctaWrapper__XNYtJ","image":"styles_image__70aJB","buttonWrapper":"styles_buttonWrapper__J6KoQ","button":"styles_button__BWl3w"};